import styled from 'styled-components';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { colors } from 'ui/theme/colors';
import { AddNew16 } from 'ui/icons/aurora/16px/AddNew16';
import { BUTTON_VARIANTS } from 'ui/button';
import { TriggerProps } from '../types';
import { StyledTriggerButton as BaseTriggerButton } from '../TriggerButton/TriggerButton.styles';

export const StyledTriggerButton = styled(BaseTriggerButton)`
  &&& {
    color: ${colors.textSecondary};

    &:hover {
      color: ${colors.textPrimary};
    }
  }
`;

export const DATA_TEST = {
  button: 'add-criteria-button',
};

export const AddCriteriaButton = ({ onClick }: Pick<TriggerProps, 'onClick'>) => {
  const { t } = useTranslation();
  return (
    <StyledTriggerButton
      data-test={DATA_TEST.button}
      type="button"
      onClick={onClick}
      variant={BUTTON_VARIANTS.GHOST}
    >
      <AddNew16 />
      {t('storybook.buttons.addCriteria')}
    </StyledTriggerButton>
  );
};
